import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorLock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M16.5 9.75a.75.75 0 0 1-.75-.75V7.5a3.75 3.75 0 0 0-7.5 0V9a.75.75 0 1 1-1.5 0V7.5a5.25 5.25 0 0 1 10.5 0V9a.75.75 0 0 1-.75.75Z"
      clipRule="evenodd"
    />
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M19 9.25A2.75 2.75 0 0 1 21.75 12v7A2.75 2.75 0 0 1 19 21.75H5A2.75 2.75 0 0 1 2.25 19v-7A2.75 2.75 0 0 1 5 9.25h14ZM20.25 12c0-.69-.56-1.25-1.25-1.25H5c-.69 0-1.25.56-1.25 1.25v7c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25v-7Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M12 12.75a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorLock;
